module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Chart-pie-28307c89e36ea8ecafa36cfc5a0fa558.svg";